module.exports = __webpack_public_path__ + "static/paths_junior_home-7b31d66b21ed5b211d2a434e7cc7ee0b.svg";